import { Outlet } from 'react-router-dom';
import { ScrollToTop } from './ScrollToTop';
import { Footer } from './footer/Footer';

/** 푸터만 있고 헤더가 없는 라우트 레이아웃 */
export const FooterOnlyLayout = () => {
  return (
    <>
      <main>
        <ScrollToTop>
          <Outlet />
        </ScrollToTop>
      </main>
      <Footer />
    </>
  );
};
